import { SanityProductFragment } from '@data/sanity/queries/types/product'

import ProductFormItem from './product-form-item'

interface ProductFormProps {
  product: SanityProductFragment
}

const ProductForm = ({ product }: ProductFormProps) => {
  const options =
    product.options.filter((option) => option.values.length > 0) ?? []

  if (options.length === 0) {
    return null
  }

  return (
    <div className="flex flex-col gap-y-2.5">
      {options.map((option) => (
        <ProductFormItem key={option.name} product={product} option={option} />
      ))}
    </div>
  )
}

export default ProductForm
